const waitingMessages = Object.freeze([
  "Following the white rabbit...",
  "Taking the red pill...",
  "Learning kung fu...",
  "Bending the spoon...",
  "Meeting Oracle...",
  "Making cookies...",
  "Social distancing...",
  "Freeing minds...",
  "Walking the path...",
  "Sensing déjà vu...",
  "Going back in...",
  "Fighting the agents...",
  "Dodging bullets...",
  "Doing the superman thing...",
  "Looking for the keymaker...",
  "Initializing Skynet library...",
  "Calculating inverse probability matrices...",
  "Counting backwards from Infinity...",
  "Waking up the minions...",
  "Charging Ozone layer...",
  "Looking for exact change...",
  "Initializing the initializer...",
  "Filling up the Falcon...",
  "Readying the boosters...",
  "Searching for the light switch...",
  "Watching netflix...er...I mean loading, yeah loading...",
  "Not panicking...",
  "Working very hard... Really!",
  "Waiting for winter to come...",
  "Finding Satoshi Nakamoto..."
]);

export default waitingMessages;
